import Blog1 from '../assets/Blog_1.png';
import Blog2 from '../assets/Blog_2.png';
import Blog3 from '../assets/Blog_3.png';

export const POST_IMAGES: Record<string, string> = {
  Blog_1: Blog1,
  Blog_2: Blog2,
  Blog_3: Blog3,
};
